import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "terms-and-conditions"
    }}>{`Terms and conditions`}</h1>
    <p>{`A `}<strong parentName="p">{`terms and conditions page`}</strong>{` is a web page that outlines the rules and restrictions for the use of a website. It acts as a contract between the website owner and its users. The primary purpose of a terms and conditions page is to establish legal guidelines for the website and protect the interests of both parties involved.`}</p>
    <p>{`You find terms and conditions here `}<inlineCode parentName="p">{`/terms`}</inlineCode>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If terms and conditions are not approved it's not appear on the shop page.`}</p>
    </blockquote>
    <h2 {...{
      "id": "admin-end"
    }}>{`Admin End`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Admin end empty Terms and Condition lists.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 1" src={require("./images/terms-and-conditions/1.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Shop end empty Terms and Condition lists.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 2" src={require("./images/terms-and-conditions/2.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Create or edit terms and condition form.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 3" src={require("./images/terms-and-conditions/3.png")} />{`
`}<img alt="terms-and-conditions 8" src={require("./images/terms-and-conditions/8.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Admin end terms and condition lists.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 4" src={require("./images/terms-and-conditions/4.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Shop end terms and condition lists.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 5" src={require("./images/terms-and-conditions/5.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Not approved terms and condition item.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 6" src={require("./images/terms-and-conditions/6.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Non approved terms and condition item not showing in shop end.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 7" src={require("./images/terms-and-conditions/7.png")} /></p>
    <h2 {...{
      "id": "vendor-shop-end"
    }}>{`Vendor Shop End`}</h2>
    <blockquote>
      <p parentName="blockquote">{`If admin active terms and condition for vendor it's available for shop and vendor.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Vendor shop end inactive terms and conditions.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 10" src={require("./images/terms-and-conditions/10.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`You find vendor shop terms and conditions settings here `}<inlineCode parentName="p">{`/settings/shop`}</inlineCode>{`.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 9" src={require("./images/terms-and-conditions/9.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Vendor shop end active terms and conditions.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 11" src={require("./images/terms-and-conditions/11.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Admin end vendor shop terms and condition lists.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 12" src={require("./images/terms-and-conditions/14.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Vendor shop end terms and conditions list.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 12" src={require("./images/terms-and-conditions/12.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Vendor shop end vendor terms and conditions list. You find vendor end terms and conditions here `}<inlineCode parentName="p">{`/shops/shopName/terms`}</inlineCode>{`.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 12" src={require("./images/terms-and-conditions/13.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      